webpackJsonp([278506522036911],{

/***/ 480:
/***/ (function(module, exports) {

	module.exports = {"data":{"contentfulMember":{"name":"Jun Cajigal","designation":"Core Member","thumbnail":{"file":{"url":"//images.ctfassets.net/1o5ly3na7qu2/4HDQ1QF77GA2Uico22AUkG/14263297d80a78f3d6cbabec45400bfc/Jun.jpg"}},"content":{"content":"![22308530 514699608897448 3202351094340711715 n](//images.contentful.com/1o5ly3na7qu2/5UQy6Oz76ESmeEgoAQoaUA/5625d4ef34e8dcacfb253fad78caf613/22308530_514699608897448_3202351094340711715_n.jpg)\n\n__Jun Cajigal__ is one of the newest additions to the MSA Cast & Crew, and eventually the MSA Core Group. He is an instructor at San Beda and adviser to the Bedan Society of Young Astronomers. He is also a huge Star Trek fan.\n\nYou, too, can be a volunteer astronomer! Join us!"}}},"pathContext":{"id":"c2SwoRsBwkESkwweqQiCC8i"}}

/***/ })

});


// WEBPACK FOOTER //
// path---member-jun-cajigal-ea53bea9634994ba4c7e.js